import { memo } from "react";
import Particles, { Container, Main } from "react-tsparticles";
import { INTERACTIVITY, SNOWFLAKE_PARTICLES } from "../../constants/particles";

interface ParticlesBackgroundProps {
  particlesInit?: (main: Main) => void;
  particlesLoaded?: (container: Container) => void;
};

function ParticlesBackground({ particlesInit, particlesLoaded }: ParticlesBackgroundProps) {


  return (
    <Particles
      id="particles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        detectRetina: true,
        particles: SNOWFLAKE_PARTICLES,
        interactivity: INTERACTIVITY
      }}
    />
  );
}

export default memo(ParticlesBackground);
